import { memo } from 'react'
import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface CreateStyleCardProps {
  onClick: () => void
  styleCount: number
  limit: number
}

const CreateStyleCard = memo(({ onClick, styleCount, limit }: CreateStyleCardProps) => {
  const { t } = useTranslation('canvas')
  const isAtLimit = styleCount >= limit

  return (
    <button
      onClick={onClick}
      disabled={isAtLimit}
      data-testid="create-style-card"
      className={`
        group relative flex flex-col items-center justify-center rounded-md
        border-2 border-dashed transition-all duration-200
        ${isAtLimit
          ? 'border-border/30 opacity-50 cursor-not-allowed'
          : 'border-border/60 hover:border-pink-400/60 hover:bg-surface-2 cursor-pointer'
        }
      `}
    >
      <div className="aspect-square w-full flex flex-col items-center justify-center gap-2">
        <Plus
          className={`w-8 h-8 ${isAtLimit ? 'text-foreground/20' : 'text-foreground/40 group-hover:text-foreground/60'}`}
        />
        <span
          className={`text-xs font-medium ${isAtLimit ? 'text-foreground/20' : 'text-foreground/50 group-hover:text-foreground/70'}`}
        >
          {isAtLimit ? t('createStyleCard.stylesCount', { count: styleCount, limit }) : t('createStyleCard.createStyle')}
        </span>
      </div>
    </button>
  )
})

CreateStyleCard.displayName = 'CreateStyleCard'
export { CreateStyleCard }
